import { ReactNode } from 'react';
import type { Rule } from './levels';
import { useRights } from './useRights';

interface CanProps {
  rule: Rule;
  children: ReactNode;
  fallback?: ReactNode;
}

// Affiche son contenu si la règle est vérifiée : <Can rule={full(RIGHTS.operation.createTest)}>…</Can>
function Can({ rule, children, fallback = null }: CanProps) {
  const { can } = useRights();
  return <>{can(rule) ? children : fallback}</>;
}

export default Can;
